import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=49cb44e4&scoped=true&"
import script from "./CopyLink.vue?vue&type=script&lang=ts&"
export * from "./CopyLink.vue?vue&type=script&lang=ts&"
import style0 from "./CopyLink.vue?vue&type=style&index=0&id=49cb44e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb44e4",
  null
  
)

export default component.exports